import {
  ChangeDetectorRef,
  Component,
  ComponentFactory,
  ComponentFactoryResolver,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Type,
  ViewContainerRef,
} from '@angular/core';
import { ChildrenOutletContexts, PRIMARY_OUTLET, RouterOutlet } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ActivateOutletEventObject } from './types';

@UntilDestroy()
@Component({
  selector: 'cf-shell-lib-named-router-outlet',
  template: ``,
})
export class NamedRouterOutletComponent implements OnInit, OnDestroy {
  @Input()
  public name = '';

  @Output()
  public activate: EventEmitter<ActivateOutletEventObject> = new EventEmitter<ActivateOutletEventObject>();

  @Output()
  public deactivate: EventEmitter<boolean> = new EventEmitter<boolean>();

  public outlet: RouterOutlet | undefined;

  constructor(
    private parentContexts: ChildrenOutletContexts,
    private location: ViewContainerRef,
    private resolver: ComponentFactoryResolver,
    private changeDetector: ChangeDetectorRef
  ) {}

  public ngOnInit() {
    this.outlet = new RouterOutlet(this.parentContexts, this.location, this.resolver, this.name, this.changeDetector);
    this.outlet.activateEvents.pipe(untilDestroyed(this)).subscribe(() => {
      this.initActivateEvents();
      this.initDeactivateEvents();
    });
    this.outlet.ngOnInit();
  }

  public ngOnDestroy() {
    if (this.outlet) {
      this.outlet.ngOnDestroy();
    }
  }

  private initActivateEvents() {
    this.parentContexts
      .getContext(this.name)
      ?.children.getContext(PRIMARY_OUTLET)
      ?.outlet?.activateEvents?.pipe(untilDestroyed(this))
      .subscribe((cmp) => {
        const cmpFactory: ComponentFactory<any> = this.resolver.resolveComponentFactory(
          this.parentContexts.getContext(this.name)?.children?.getContext(PRIMARY_OUTLET)?.route?.component as Type<any>
        );
        this.activate.emit({
          cmpFactory,
          component: cmp,
        });
      });
  }

  private initDeactivateEvents() {
    this.parentContexts
      .getContext(this.name)
      ?.children.getContext(PRIMARY_OUTLET)
      ?.outlet?.deactivateEvents?.pipe(untilDestroyed(this))
      .subscribe(() => {
        this.deactivate.emit(true);
      });
  }
}
